/**
 * 登录
 * lechen
 */

import React from 'react';
import './login.less';
import { withRouter } from 'react-router-dom';
import { Form, Input, Button, Checkbox, Modal, message } from 'antd';
import { Account } from "../../../models/plat/Account";
import { DoLogin, sendCode, checkCode, faceSign } from "../../../services/plat/UserService";
import { ChangePassByAccount } from "../../../services/dct/DctService";
import { Encrypt } from "../../../utils/crypto";
import utils from "../../../utils/utils";

import { createFromIconfontCN } from '@ant-design/icons';
import { readCheckAgreement, readTenantCode, readUserCode, readUserName, writeAccessToken, writeCheckAgreement, writeTenantCode, writeTenantConfiguration, writeUserInfo } from '../../../utils/storage';
import { publishLogin, publishRedirectSignup } from '../../../utils/ps';
import { isTenant067 } from '../../../utils/tenant-assoc';
const layout = {
    layout: "vertical",
    wrapperCol: {
        span: 24,
    },
};

const MyIcon = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2343612_u4ool4i00dn.js', // 在 iconfont.cn 上生成
});

const checkPhone = (value)=> {
    return /^1[3-9]\d{9}$/.test(value)
}

class AppLogin extends React.Component {

    constructor(props) {
        super(props);

        this.changePwdFormRef = React.createRef();

        this.state = {
            isModalVisible: false,
            checkAgreement: false,
            passWordType: 'password',
            secondsLeft: null,
            isCodeVisible: false,
            userName: '',
            phoneCode: '',
            account: '',
            user: {}, // 登录的用户信息
            faceSignVisible: false, // 人脸签约弹窗
            faceContent: '', // 弹窗内容
            signUrl: '', // 二维码地址
            weakPwdVisible: false, // 弱口令修改密码弹窗
            changePwdLoading: false // 修改密码提交loading
        }
    }

    componentDidMount() {
        if (readCheckAgreement()) {
            this.setState({
                checkAgreement: true
            })
        }
        
    }

    loginPage = () => {
        let loginPage = 'default';

        let lastTenant = undefined;
        let tenantCode = readTenantCode();
        if (tenantCode && tenantCode.trim().length > 0) {
            lastTenant = tenantCode;
        }

        if (!lastTenant) {
            return loginPage;
        }

        if (lastTenant === 'TENANT-013') {
            return 'hd';
        } else {
            return loginPage
        }
    };

    /**
     * 登录成功
     */
    onFinish = async values => {
        if (!this.state.checkAgreement) {
            message.info('请先阅读并同意知情同意书')
            return false;
        }

        // 前端检测弱口令：密码长度不足8位 或 不包含大小写字母和数字
        // 【已停用】不再拦截弱口令、不再弹窗强制修改密码，直接走正常登录
        // const weakPassword = !values.passWord ||
        //     values.passWord.length < 8 ||
        //     !/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/.test(values.passWord);
        //
        // if (weakPassword) {
        //     // 弹窗修改密码，暂不发起登录请求
        //     this.setState({
        //         weakPwdVisible: true,
        //         account: new Account(values)
        //     })
        //     return
        // }

        const { tenantCode } = utils.getUrlParams()

        let account = new Account(values);
        this.setState({
            account
        })
        let params = {
            userCode: account.userCode,
            passWord: Encrypt(account.passWord),
        }

        if (tenantCode) {
            params.tenantCode = tenantCode
        }

        // 取消注释 启用短信验证（需要将表单中的phoneCode字段取消注释）
        // 账号为手机号码时进行短信校验
        // if (checkPhone(values.userCode)) {
        //     const ok = await checkCode({
        //         phone: values.userCode,
        //         phoneCode: values.phoneCode
        //     })

        //     if (!ok) {
        //         return
        //     }
        // }

        DoLogin(params).then(user => {
            if (user) {
                const regExp = new RegExp(/^1[3-9]\d{9}$/);
                const allowedPhones = ['15156684934', '18255848434'];
                if(user.isJs == 1 && regExp.test(account.userCode) && allowedPhones.includes(String(account.userCode))){
                    this.setState({
                        isCodeVisible: true,
                        user
                    })
                    return
                }

                // 先临时写入 token，保证 faceSign 请求能带上正确的 x-auth-token
                writeAccessToken(user.token)
                
                this.setState({ user }, () => {
                    this.checkFaceSign(account.userCode)
                })
              
            }
        })

    };
    /**
     * 保存登录信息
     */
    saveLoginInfo = (user)=>{
        // 君实生物 强转
        if (user.tenantConfig) {
            user.tenantConfig.label = user.tenantConfig.label === 1 ? '患者' : '受试者'
        } else {
            user.tenantConfig = {
                label: '受试者'
            }
        }

        const {roleCode, roleCodes, token, userCode, userName, tenantName, tenantCode} = user

        writeCheckAgreement(true)

        writeTenantCode(user.tenantCode)

        writeTenantConfiguration(user.tenantConfig)

        writeAccessToken(token)

        writeUserInfo({ roleCode, roleCodes, userCode, userName, tenantName, tenantCode })

        publishLogin()
        
        this.props.history.push("/index");
    }

    /**
     * 检查人脸签约
     */
    checkFaceSign = (userCode) => {
        const { user } = this.state;
        if (user && user.token) {
            writeAccessToken(user.token);
        }
        faceSign({ userCode }).then(res => {
            if (res && res.showPopup === 1) {
                this.setState({
                    faceSignVisible: true,
                    faceContent: res.faceContent || '',
                    signUrl: res.signUrl || ''
                })
            } else {
                this.saveLoginInfo(this.state.user)
            }
        }).catch(() => {
            this.saveLoginInfo(this.state.user)
        })
    }

    /**
     * 重新检查签约状态
     */
    handleRefreshFaceSign = () => {
        const { user } = this.state;
        if (user && user.userCode) {
            this.checkFaceSign(user.userCode)
        }
    }

    /**
     * 注册事件
     */
    registerEvent = () => {
        publishRedirectSignup()
    }

    /**
     * 登录失败
     */
    onFinishFailed = (errorInfo) => {
        console.log('Failed:', errorInfo);
    };


    handleSure = () => {
        this.setState({
            checkAgreement: true,
            isModalVisible: false
        })
    }


    //同意协议checkbox改变
    onCheckboxChange = (e) => {
        if (!this.state.checkAgreement) {
            this.setState({
                isModalVisible: true
            })
            return false;
        }
        this.setState({
            checkAgreement: e.target.checked
        })
    };

    //显示服务协议模态框
    showModal = (e) => {
        this.setState({ isModalVisible: true })
    };

    //改变密码框类型
    changePassWordType = () => {
        if (this.state.passWordType === 'password') {
            this.setState({ passWordType: 'text' })
        } else {
            this.setState({ passWordType: 'password' })
        }
    }

    getPassWordIcon = () => {
        return this.state.passWordType === 'password' ? <MyIcon className='fontIcon' type='iconpassword_disvisible' onClick={this.changePassWordType} /> :
            <MyIcon className='fontIcon' type='iconpassword_visible' onClick={this.changePassWordType} />
    }
    // 发送验证码
    async handleSend() {
        const phone = this.state.userName || sessionStorage.getItem('userName')

        if (!/^1[3-9]\d{9}$/.test(phone)) {
            message.error("请输入手机号码！")
            return
        }

        try {
            await sendCode({ phone })
            this.startCountdown(60)
            message.success("验证码已发送")
        } catch (error) {
            
        }
    }
    handleGetCode = async () => {
        // 发送请求到后端获取验证码
        sendCode({
            phone: this.state.account.userCode
        }).then(data=>{
            this.startCountdown(60); // 假设倒计时为60秒
        })

    }
    startCountdown = (time) => {
        let countdown = time;
        const interval = setInterval(() => {
            this.setState({
                secondsLeft: countdown
            })
            if (countdown <= 0) {
                clearInterval(interval);
                this.setState({
                    secondsLeft: null
                })
            } else {
                countdown -= 1;
            }
        }, 1000);
    }
    /**
     * 弱口令弹窗 - 提交修改密码，成功后自动登录
     */
    handleWeakPwdSubmit = () => {
        const form = this.changePwdFormRef.current;
        if (!form) return;
        const { account } = this.state;
        
        form.validateFields().then(values => {
            this.setState({ changePwdLoading: true });
            const params = {
                userCode: values.userCode || account.userCode,
                oldPass: Encrypt(values.oldpassword),
                newPass: Encrypt(values.newpassword)
            }
            ChangePassByAccount(params).then(res => {
                if (res && res.code == 0) {
                    message.success('密码修改成功，正在登录...');
                    // 修改成功后用新密码登录
                    const userCode = values.userCode || account.userCode;
                    this.doLogin(userCode, values.newpassword);
                } else {
                    this.setState({ changePwdLoading: false });
                    message.error(res.message || '密码修改失败');
                }
            }).catch(() => {
                this.setState({ changePwdLoading: false });
            })
        }).catch(() => {})
    }

    /**
     * 执行登录
     */
    doLogin = (userCode, passWord) => {
        const { tenantCode } = utils.getUrlParams();
        const params = {
            userCode: userCode,
            passWord: Encrypt(passWord),
        };
        if (tenantCode) {
            params.tenantCode = tenantCode;
        }
        DoLogin(params).then(user => {
            this.setState({ weakPwdVisible: false, changePwdLoading: false });
            if (user) {
                writeAccessToken(user.token);
                this.setState({ user }, () => {
                    this.checkFaceSign(userCode);
                });
            }
        }).catch(() => {
            this.setState({ weakPwdVisible: false, changePwdLoading: false });
        })
    }

    /**
     * 弱口令弹窗 - 取消修改（不登录）
     */
    handleWeakPwdCancel = () => {
        this.setState({ weakPwdVisible: false, user: {} })
    }

    // 校验验证码
    handleCodeSure = ()=> {
        const { phoneCode, user, account } = this.state;
        if(!phoneCode){
            return message.error("请输入验证码！")
        }
        checkCode({
            phone: account.userCode,
            phoneCode
        }).then(data=>{
           if(data){
                this.setState({
                    isCodeVisible: false,
                    phoneCode: '',
                })

               this.saveLoginInfo(user)
           }

        })
    }
    render() {
        const { secondsLeft, isCodeVisible, phoneCode, faceSignVisible, faceContent, signUrl, weakPwdVisible, changePwdLoading } = this.state;
        const loginPage = this.loginPage();
        return (
            <div className={loginPage === 'default' ? 'login' : 'login_' + loginPage}>
                <div className={"login_con"}>
                    <div className={"title_box"}>
                        <h1 className={"title"}>科研数据小助手</h1>
                        <div className={"title_tips"}>Electronic Data Capture Platform</div>
                    </div>
                    <div className={"login_main"}>
                        <Form
                            {...layout}
                            name="basic"
                            initialValues={{ remember: true }}
                            requiredMark={false}
                            onFinish={this.onFinish}
                            onFinishFailed={this.onFinishFailed}
                        >
                            <Form.Item
                                label="账号"
                                name="userCode"
                                onChange={({target})=> { this.setState({
                                    userName: target.value
                                })}}
                                rules={[{ required: true, message: '请输入账号！' }]}
                                initialValue={readUserCode()}
                            >
                                <Input placeholder="请输入账号" style={{ height: 40 }} />
                            </Form.Item>
                            <Form.Item
                                label="密码"
                                name="passWord"
                                rules={[{ required: true, message: '请输入密码!' }]}
                            >
                                <Input
                                    type={this.state.passWordType}
                                    placeholder="请输入密码"
                                    suffix={this.getPassWordIcon()}
                                />
                            </Form.Item>
                            {/*                             
                            <Form.Item
                                label="验证码"
                                name="phoneCode"
                                rules={[{ required: true, message: '请输入验证码!' }, {len: 6, message: '验证码输入错误'}]}
                            >
                                <Input
                                    type={this.state.phoneCode}
                                    placeholder="请输入验证码"
                                    autoComplete='off'
                                    suffix={
                                        <Button disabled={this.state.secondsLeft > 0} style={{zIndex: 999}} onClick={()=> this.handleSend()} size="small" type="link">{this.state.secondsLeft > 0 ? `${this.state.secondsLeft}秒后重发`: '发送验证码'}</Button>
                                    }
                                />
                                
                            </Form.Item>
                             */}
                            <Form.Item >

                                <Checkbox checked={this.state.checkAgreement} onChange={this.onCheckboxChange}>
                                </Checkbox>
                                <span className={'agreement'}>
                                    已阅读并同意
                                    <span className='view_agreement' onClick={() => this.setState({ isModalVisible: true })}>《知情同意书》</span>
                                </span>
                            </Form.Item>
                            <Form.Item className='action_submit'>
                                {/* <div className={'login_register'} onClick={this.registerEvent}>
                                    注册账号
                                </div> */}
                                <Button className={"submit"} type="primary" htmlType="submit">
                                    登录
                                </Button>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
                <Modal
                    title="知情同意书"
                    open={this.state.isModalVisible}
                    cancelText='不同意'
                    okText='同意'
                    onOk={this.handleSure}
                    onCancel={() => this.setState({ isModalVisible: false, checkAgreement: false })}>
                    <p>本人所在的药店并未对我参与此项目做出任何禁止性规定，且本人填写的信息内容已获取患者的同意，并已按照个人信息保护相关法律法规的要求向患者履行告知义务。</p>
                </Modal>
                    
                <Modal 
                    className={'login_code_modal'}
                    title="手机号验证码校验"  
                    cancelText='取消'
                    okText='确定'
                    onOk={this.handleCodeSure } 
                    open={isCodeVisible}
                    onCancel={() => this.setState({ isCodeVisible: false, phoneCode: null})}>
                    <div className={"login_code"}>

                         <Input.Group compact>
                            <Input
                                style={{
                                    width: 'calc(100% - 200px)',
                                }}
                                value={phoneCode}
                                onChange={(e) => this.setState({
                                    phoneCode: e.target.value
                                })}
                                placeholder="请输入手机验证码"
                                maxLength="6"
                            />
                            <Button type='primary' onClick={this.handleGetCode} disabled={secondsLeft !== null}   >
                                {secondsLeft !== null ? `${secondsLeft} 秒后重试` : '获取验证码'}
                            </Button>
                        </Input.Group>

                    </div>    
               
                </Modal>

                <Modal
                    className={'face-sign-modal'}
                    title={null}
                    open={faceSignVisible}
                    closable={false}
                    maskClosable={false}
                    keyboard={false}
                    footer={null}
                    width={520}
                >
                    <div 
                        style={{ maxWidth: 600, textAlign: 'center', padding: '40px 20px' }}
                        dangerouslySetInnerHTML={{ __html: faceContent }}
                    />
                    {signUrl && (
                        <div style={{ marginTop: 30, textAlign: 'center' }}>
                            <img 
                                src={signUrl} 
                                alt="签约二维码" 
                                style={{ width: 200, height: 200 }}
                            />
                            <div style={{ marginTop: 20, color: '#666', fontSize: 14 }}>
                                请使用微信扫描二维码完成签约
                            </div>
                        </div>
                    )}
                    <div style={{ marginTop: 40, textAlign: 'center' }}>
                        <Button type="primary" size="large" onClick={this.handleRefreshFaceSign}>
                            我已完成签约，刷新页面
                        </Button>
                    </div>
                </Modal>

                <Modal
                    title="修改密码"
                    open={weakPwdVisible}
                    okText='确认修改'
                    cancelText='暂不修改'
                    confirmLoading={changePwdLoading}
                    onOk={this.handleWeakPwdSubmit}
                    onCancel={this.handleWeakPwdCancel}
                    destroyOnClose
                >
                    <p style={{ color: '#e6a23c', marginBottom: 16 }}>您的密码为弱口令，为了账户安全，请立即修改密码</p>
                    <Form
                        ref={this.changePwdFormRef}
                        labelCol={{ span: 5 }}
                        wrapperCol={{ span: 18 }}
                        autoComplete="new-password"
                    >
                        <Form.Item
                            label="账号"
                            name="userCode"
                            initialValue={this.state.account?.userCode || ''}
                            rules={[{ required: true, message: '请输入账号!' }]}
                        >
                            <Input allowClear autoComplete="off" />
                        </Form.Item>
                        <Form.Item
                            label="旧密码"
                            name="oldpassword"
                            rules={[{ required: true, message: '请输入旧密码!' }]}
                        >
                            <Input.Password allowClear autoComplete="new-password" />
                        </Form.Item>
                        <Form.Item
                            label="新密码"
                            name="newpassword"
                            rules={[
                                { required: true, message: '请输入新密码!' },
                                {
                                    pattern: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d).+$/,
                                    message: '新密码必须包含大写字母、小写字母和数字'
                                },
                                { min: 8, message: '新密码长度至少8位' }
                            ]}
                        >
                            <Input.Password allowClear autoComplete="new-password" />
                        </Form.Item>
                    </Form>
                </Modal>
            </div>
        )
    }
}

export default withRouter(AppLogin);


